import { Field } from "formik";
import { styled } from "styled-components";
import { Assets } from "../styles/assets";

export const InputTextContainer = styled.div`
  width: 100%;
  height:auto;
  display: flex;
  flex-direction: column;  
`;

export const InputTextStyle = styled.input`
  width: 100%;  
  height: ${Assets.heightInput};
  border-radius: 5px;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: transparent;
  border: 1.5px solid #2A2A2A;
  color: #9CA3AF;
  font-size: 16px;  
  outline: none;
  transition: border-color .15s ease-in-out;
  &::placeholder {
    color: #444;
    font-size: 16px;    
  };  
  &:focus {
    border-color: rgba(4,249,204,0.5); 
  }
`;
/*
.input-field::placeholder { color: #444; }
.input-field:focus {  }
.input-hint { font-size: 11px; color: #444; margin-top: 6px; }
*/

export const InputTextFormikStyle = styled(Field)<{ marginbottom?: string }>`
  width: 100%;  
  height: ${Assets.heightInput};
  border-radius: 5px;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: transparent;
  border: 1.5px solid #2A2A2A;
  color: #9CA3AF;
  font-size: 16px;  
  outline: none;
  margin-bottom: ${({ marginbottom }) => marginbottom || "20px"};
  transition: border-color .15s ease-in-out;
  &::placeholder {
    color: #444;
    font-size: 16px;    
  };  
  &:focus {
    border-color: rgba(4,249,204,0.5); 
  }
`;